import { render } from "./PointForm.vue?vue&type=template&id=62ec2088"
import script from "./PointForm.vue?vue&type=script&lang=js"
export * from "./PointForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__